import React, { useEffect, useState } from 'react'
// import antIcon from '../uielements/Spinner/spin';
import { LoadingOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { actions, sessionLogin, verifyEmail, } from '../../store/auth/actions';
import { selectError, selectLoader } from '../../store/ui/selector';
import { RootState } from '../../config/store';
import { getUserBasicProfile } from '../../store/profile/actions';


const SignUpVerification = (props: any) => {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const { isLoggedIn } = useSelector((store: RootState) => store.auth);
    const { getBasicProf } = useSelector((store: RootState) => store.profile);

    const { txnId, token } = useParams();


    const cntd = <LoadingOutlined style={{ fontSize: 89, color: 'blue' }} spin />;

    const right = <CheckCircleOutlined style={{ fontSize: 89, color: 'green' }} />;

    const wrong = <CloseCircleOutlined style={{ fontSize: 89, color: 'red' }} />;

    // console.log(props.error)

    useEffect(() => {
        if (isLoggedIn) {
            return navigate("/dashboard/home");
        }
    }, [isLoggedIn]);

    // useEffect(() => {

    //     if ((getBasicProf as any).User.ActiveRole == "ORG_ADMIN" && (getBasicProf as any).User.UserJourney == 1) {
    //         return navigate("/org-details");
    //     }
    //     if ((getBasicProf as any).User.ActiveRole == "ORG_EMPLOYEE" && (getBasicProf as any).User.UserJourney == 2) {
    //         return navigate("/admin-dashboard");
    //     }
    // }, [getBasicProf]);

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(verifyEmail({ TransactionId: txnId as string, Token: token as string }))
    }, []);

    return (
        <main>
            <section className="signup__area po-rel-z1 pt-100 pb-145">
                <div className="sign__shape">
                    {/* <img className="man-1" src="assets/img/icon/sign/man-3.png" alt="img not found" />
                    <img className="man-2 man-22" src="assets/img/icon/sign/man-2.png" alt="img not found" /> */}
                    <img className="circle" src="/assets/img/icon/sign/circle.png" alt="img not found" />
                    <img className="zigzag" src="/assets/img/icon/sign/zigzag.png" alt="img not found" />
                    <img className="dot" src="/assets/img/icon/sign/dot.png" alt="img not found" />
                    <img className="bg" src="/assets/img/icon/sign/sign-up.png" alt="img not found" />
                    <img className="flower" src="/assets/img/icon/sign/flower.png" alt="img not found" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-8 offset-xxl-2 col-xl-8 offset-xl-2">
                            <div className="section__title-wrapper text-center mb-55">
                                <h2 className="section__title">Verification <br />  In Progress</h2>
                                <p>I'm a subhead that goes with a story.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xxl-6 offset-xxl-3 col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                            <div className="sign__wrapper white-bg">
                                <div className="sign__form">
                                    {props.isLoading && !props.error && (<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                        {cntd}<br></br><br></br>
                                        <span style={{ fontSize: 30, textAlign: 'center' }}>Please wait...</span>
                                    </div>)}
                                    {props.error && (<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                        {wrong}<br></br><br></br>
                                        <span style={{ fontSize: 30, textAlign: 'center' }}>{props.error[0].message}</span>
                                    </div>)}
                                    {!props.isLoading && !props.error && (<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                        {right}<br></br><br></br>
                                        <span style={{ fontSize: 30, marginLeft: 72 }}>Email Verified</span>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}


const mapStateToProps = (state: RootState) => {
    return {
        isLoading: selectLoader(actions.VERIFY_EMAIL)(state),
        error: selectError(actions.VERIFY_EMAIL)(state),
    };
};

export default connect(mapStateToProps)(SignUpVerification)